import * as React from "react";

import { shimmerStyles } from "../utils/shimmerStyles";

const ToolBlock = ({
  message,
  icon,
  isLoading,
}: {
  message: string;
  icon: React.ReactNode;
  isLoading?: boolean;
}) => {
  return (
    <div className="flex flex-row items-center gap-1">
      {icon}

      <div className="text-muted" style={isLoading ? shimmerStyles : {}}>
        {message}
      </div>
    </div>
  );
};

export default ToolBlock;
